import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  public user;
  public selectedUser;
  private _isGuest$: BehaviorSubject<Boolean> = new BehaviorSubject(false);
  public isGuest$ = this._isGuest$.asObservable();
  public _userInTest$: BehaviorSubject<Boolean> = new BehaviorSubject(false);
  public userInTest$ = this._userInTest$.asObservable();

  constructor( private http: HttpClient) { }

  setUserInTest(value){
    this._userInTest$.next(value);
  }

  setIsGuest(value){
    this._isGuest$.next(value);
  }

  login( data ):Observable<any> {
    return this.http.post(`${environment.apiBaseUrl}/users/userLogin`, data);
  }

  register ( data ):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/users/register`, data);
  }

  getUser(): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.get(`${environment.apiBaseUrl}/users/getUser`,{
      headers:{
        token:token
      }
    });
  }

  getUsers():Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.get(`${environment.apiBaseUrl}/users/getUsers`,{
      headers:{
        token:token
      }
    });
};

  getUserByEmail(email):Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/users/getUserByEmail?email=${email}`);
  }
  
  updateUser( data ):Observable<any> {  
    return this.http.put(`${environment.apiBaseUrl}/users/updateUser`, data, {
    });
  }

  requestNewPassword(email):Observable<any>{
    let obj = {
      email:email
    }
    return this.http.post(`${environment.apiBaseUrl}/users/requestNewPassword`, obj);
  }

  getUserByQuery(query: object):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/users/getUserByQuery`, query);
  }

  sendEmailFromClient(html: string, email: string, subject: string):Observable<any>{
    return this.http.post(`${environment.apiBaseUrl}/users/sendEmailFromClient`, {
      html: html,
      email: email,
      subject: subject
    });
  }

  getUsersWithPayments(): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.get(`${environment.apiBaseUrl}/users/getUsersWithPayments`, {
      headers: {
        token: token
      }
    });
  }


}


